module.exports = __webpack_public_path__ + "img/Hidden-Number-3.cd6aa02e.svg";